import { render, staticRenderFns } from "./cowVaccinationDue.vue?vue&type=template&id=f80aefbc&scoped=true&"
import script from "./cowVaccinationDue.vue?vue&type=script&lang=js&"
export * from "./cowVaccinationDue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80aefbc",
  null
  
)

export default component.exports